import { envConfig } from '../../../../env';
import { Post } from '../../../service/request/server';

const baseUrl = envConfig.formalServer + "/cotton/admin/log/"

function baseApi() {
    function deleteLog(data) {
        return Post(baseUrl + 'deleteLog', data);
    }

    function queryLog(data) {
        return Post(baseUrl + 'queryLog', data);
    }

    function queryProjectNameList() {
        return Post(baseUrl + 'queryProjectNameList', {});
    }

    return {
        deleteLog, queryLog, queryProjectNameList
    };
}

export const logApi = baseApi()
